module.exports = function anonymous(locals, filters, escape, rethrow) {
    escape = escape || function(html) {
        return String(html).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;");
    };
    var __stack = {
        lineno: 1,
        input: '<img class="chevron_footer" src="img/chevron_footer_down.png" />\n<div class="actually">\n</div>\n<div class="next">\n</div>',
        filename: "."
    };
    function rethrow(err, str, filename, lineno) {
        var lines = str.split("\n"), start = Math.max(lineno - 3, 0), end = Math.min(lines.length, lineno + 3);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    }
    try {
        var buf = [];
        with (locals || {}) {
            (function() {
                buf.push('<img class="chevron_footer" src="img/chevron_footer_down.png" />\n<div class="actually">\n</div>\n<div class="next">\n</div>');
            })();
        }
        return buf.join("");
    } catch (err) {
        rethrow(err, __stack.input, __stack.filename, __stack.lineno);
    }
}


//////////////////
// WEBPACK FOOTER
// /home/app/terminal/release/1768227843-2.1.11/node_modules/ejs-compiled-loader!./src/templates/popup_footer.ejs
// module id = 141
// module chunks = 0